import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { EncryptionService } from 'src/app/encryption.service';

@Component({
  selector: 'app-visitor-home',
  templateUrl: './visitor-home.component.html',
  styleUrls: ['./visitor-home.component.scss']
})
export class VisitorHomeComponent implements OnInit {

  constructor(public appservice:AppService,private activeRoute: ActivatedRoute,
    private encryptionService: EncryptionService, public router: Router) { 
    // const encryptedNumber = this.encryptionService.encrypt("2");
    // console.log(encryptedNumber); 
    //var id = this.activeRoute.snapshot.queryParamMap.get('returnUrl');

  }


  checkin()
  {
    return this.router.navigate(['/visitor-phone']);
  }

  checkout()
  {
    return this.router.navigate(['/visitor-phone']);
  }


  ngOnInit(): void {
    this.activeRoute.fragment.subscribe(fragment => {
      
      var encryptedNumber = "";
      if (fragment) {
        console.log('Value:', ); // This will log 'hash' when the URL is #/one#hash
        console.log('Fragment:', fragment); // This will log 'hash' when the URL is #/one#hash
        encryptedNumber = fragment.replace("/visitor-home/",""); 
      }
      else {
        encryptedNumber = this.activeRoute.snapshot.paramMap.get('id'); 
      }

      if (encryptedNumber) {
        const decryptedNumber = this.encryptionService.decrypt(encryptedNumber);
        console.log(decryptedNumber); 
         this.appservice.Company = "_"+decryptedNumber;
         this.appservice.setItem("Company",decryptedNumber);
         this.appservice.get_Area_Details();
      }
    });
  }

}
